var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.328,
    height: 26.328,
    viewBox: "0 0 26.328 26.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow",
    transform: "translate(14.155 26.328) rotate(-135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2548",
    "data-name": "Group 2548",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M11.41,0,10.3,1.105l6.721,6.721H0V9.389H17.026L10.3,16.11l1.105,1.105,8.608-8.608Z",
    fill: "#ff5440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow);
export default __webpack_public_path__ + "static/media/red-arrow.c7a9796502eb9c02342ae534b61a1501.svg";
export { ForwardRef as ReactComponent };